import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=55627eac&scoped=true"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"
import style0 from "./Applications.vue?vue&type=style&index=0&id=55627eac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55627eac",
  null
  
)

export default component.exports